import { useEffect } from 'react'
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom'

import { routeMap } from '@core/constants/routes'
import { useMainState } from '@core/main-state'

const MyFolderRedirect = () => {
  const nestedFolders = useMainState((state) => state.customer?.features?.nested_folders)
  const navigate = useNavigate()
  const location = useLocation()
  const checkRoutes = [{ path: routeMap.DELIVER_ROUTE }, { path: routeMap.DELIVER_PROJECT_ROUTE }]
  const matchedRoutes = matchRoutes(checkRoutes, location) || []
  const matchedRoute = matchedRoutes?.length > 0 ? matchedRoutes[0] : null

  useEffect(() => {
    if (nestedFolders && matchedRoute) {
      const { params, route } = matchedRoute
      const folderId = params?.projectId || ''
      if (route.path === routeMap.DELIVER_PROJECT_ROUTE) {
        navigate(routeMap.MY_FOLDER_ROUTE.replace(':folderId', folderId), { replace: true })

        return
      }
      navigate(routeMap.MY_FOLDERS_ROUTE, { replace: true })
    }
  }, [nestedFolders, navigate, matchedRoute])
  return null
}

export default MyFolderRedirect
